import { Directive, HostBinding } from '@angular/core';

@Directive({
  selector: '[featurePermissionAny]'
})
export class FeaturePermissionAnyDirective {

  private _disabled = true;

  constructor() { }

  @HostBinding('attr.disabled') get isDisabled() { return this._disabled ? '' : null; }

  set disabled(val: boolean) {
    this._disabled = val;
  }
}
